// extracted by css-extract-rspack-plugin
export default {"modal":"UOVhY9qYHeURshiX"};